import { useEffect, useState } from 'react';
import debounce from 'lodash.debounce';
import { useLayoutEffect } from '@hooks/useIsomorphicLayoutEffect';

export enum Breakpoints {
  // Legacy breakpoints
  sm = 480,
  md = 720,
  lg = 1088,
  xl = 1260,
  xxl = 1616,

  // New Figma breakpoints
  mobile = 390,
  tablet = 480,
  tabletLg = 720,
  tabletXl = 988,
  desktop = 1440,
  desktopLg = 1920,
  desktopXl = 2560,
}

const useBreakpoint = (breakpoint: number = Breakpoints.md) => {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    const handleResizeWindow = debounce(() => setWidth(window.innerWidth), 200);
    window.addEventListener('resize', handleResizeWindow);
    return () => {
      window.removeEventListener('resize', handleResizeWindow);
    };
  }, [setWidth]);

  const isBelowBreakpoint = width < breakpoint;

  return isBelowBreakpoint;
};

export default useBreakpoint;
